import React, { useState, useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import OrganizationRole from '../UI/OrganizationRole';
import PrimaryModal from '../UI/Modal/PrimaryModal';
import UpdatePassword from './UpdatePassword';
import DeactivateAccount from './DeactivateAccount';
import SuccessModal from './SuccessModal';
import { deactivateUser, updateOrganizationRole, updateUserProfile } from '../../utils/APIs';
import SuccessAlert from "../../components/UI/Alert/SuccessAlert";
import { useUserContext } from '../../contexts/UserContext';
import { toast } from 'react-toastify';
import Loader from '../UI/Loader/Loader';
import ConfirmModal from '../UI/Modal/confirmModal';
import { SecondaryButton } from "../UI";
import Input from '../UI/Input';
import { permission } from '../../config/permission';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const UpdateUserModal = ({ setUpdateUser, selectedUser ,loading,setLoading,isUserBlocked,setIsUserBlocked,isRoleChange, setIsRoleChange}) => {
    const { getAccessTokenSilently } = useAuth0();
    const { userData, roles, checkPermission } = useUserContext();
    const { content } = useContentfulContext();

    const [showUpdatePassword, setShowUpdatePassword] = useState(false);
    const [showDeactivateAccount, setShowDeactivateAccount] = useState(false);
    const [countdown, setCountdown] = useState(content.SEND_VERIFICATION_SUCCESS_MODAL.timeout);
    const [isCountdownActive, setIsCountdownActive] = useState(false);
    const [userName, setUserName] = useState(selectedUser.name);
    const [orgRole, setOrgRole] = useState(selectedUser.roles);
    const [userValid, setUserValid] = useState(false); 
    const [showSuccess, setShowSuccess] = useState(false);
    // const [isRoleChange, setIsRoleChange] = useState(false)
    const [openConfirmDeactivate, setOpenConfirmDeactivate] = useState(false)
    const [handleConfirmation, setHandleConfirmation] = useState(false)
    const startCountdown = () => {
      setIsCountdownActive(true);
      setCountdown(content.SEND_VERIFICATION_SUCCESS_MODAL.timeout);

      const countdownInterval = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown === 1) {
            clearInterval(countdownInterval);
            setIsCountdownActive(false);
            setUpdateUser(false);
            return 0;
          }
          return prevCountdown - 1;
        });
      }, 1000);
    };

    useEffect(() => {
      if (countdown === 0) {
        setIsCountdownActive(false);
      }
    }, [countdown]);

    useEffect(() => {
        if(userName != selectedUser.name || orgRole != selectedUser.organization_role) {
            setUserValid(true);
        } else {
            setUserValid(false);
        }
    }, [userName, orgRole,loading,isUserBlocked]);
    const handleSaveChanges = async () => {
        setIsRoleChange(true)
        try {
            const token = await getAccessTokenSilently();

            if(selectedUser.roles != orgRole) {
                const data = {
                    userId: selectedUser?.user_id,
                    roleId: orgRole, 
                    organizationId: userData.selectedOrganization.org_token, 
                    deletedRoleId: selectedUser.roles, 
                }
                await updateOrganizationRole(token, data)
            }
            const result = await updateUserProfile(token, selectedUser?.user_id, { name: userName, }, userData?.selectedOrganization?.org_token);
           
            setUserName(result.data.name);
            result && setIsRoleChange(false)
            setShowSuccess(true);
        } catch (error) {
            setIsRoleChange(false)
            console.log("error", error);
        }
    };

    useEffect(() => {
        setOrgRole(selectedUser?.roles)
    }, [selectedUser])

    const handleDeactivateAccount = async () => {
        setLoading(true)
        const result = await deactivateUser(userData.token, selectedUser.user_id, userData?.selectedOrganization?.org_token)
        if(result.status) {
            setLoading(false)
            setUpdateUser(false);
            setIsUserBlocked(!isUserBlocked)
            toast.success(result.message)
        } else {
            setLoading(false)
            toast.error(result.message)
        }
     }
     const handleActivateAccount = async () => {
            setLoading(true)
            const result = await updateUserProfile(userData.token, selectedUser.user_id,{
                blocked: false
              }, userData?.selectedOrganization?.org_token)
            if(result.status) {
                setIsUserBlocked(!isUserBlocked)
                setLoading(false)
                setUpdateUser(false);
                toast.success("User activate succesfully")
            } else {
                setLoading(false)
                toast.error(result.message)
            }
       
     }
    
      useEffect(()=>{
        const handleAccountConfirmation = () => {
            if (handleConfirmation) {
              if (!isUserBlocked) {
                handleDeactivateAccount();
              } else if (isUserBlocked) {
                handleActivateAccount();
              }
            }
          };
        handleAccountConfirmation()
      },[handleConfirmation])
    return (
        <>
        {(loading && <Loader />)  || (isRoleChange && <Loader /> )}
        {openConfirmDeactivate && (
        <ConfirmModal
          title={`Confirm to ${isUserBlocked ? 'Activate' : 'Deactivate'} your Account`}
          hideModal={setOpenConfirmDeactivate}
          handleConfirmation={setHandleConfirmation}
        />
      )}

         
            { showSuccess && <SuccessAlert disappearTime={content.PROFILE_CONTENT.timeout} >{content.PROFILE_CONTENT.errors.FE117}</SuccessAlert> }
            { isCountdownActive && <SuccessModal countdown={countdown} trigger={setUpdateUser} description={content.SEND_VERIFICATION_SUCCESS_MODAL.description} cta_text={content.SEND_VERIFICATION_SUCCESS_MODAL.close_cta_text} title={content.SEND_VERIFICATION_SUCCESS_MODAL.title} /> }
         {
             !isCountdownActive && <PrimaryModal title={content.UPDATE_USER_MODAL_CONTENT.title} hideModal={setUpdateUser}>
                { showUpdatePassword && <UpdatePassword setShowUpdatePassword={setShowUpdatePassword} selectedUser={selectedUser}/> }
                { showDeactivateAccount && <DeactivateAccount setShowDeactivateAccount={setShowDeactivateAccount} /> }
                { (!showUpdatePassword && !showDeactivateAccount) && <>
                    <div className="p-6 space-y-6">
                        <Input
                            id="email"
                            name="email"
                            label={content.UPDATE_USER_MODAL_CONTENT.input.email}
                            disabled
                            value={selectedUser.email}
                            className="mb-4"
                        />
                        <div className='p-4 border border-gray-2 rounded-lg'>
                            <Input
                                id="name"
                                name="name"
                                label={content.UPDATE_USER_MODAL_CONTENT.input.name}
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                                disabled={!checkPermission(permission.MANAGE_USERS_OP_EDIT_NAME)}
                                className="mb-4"
                            />
                            <div className='relative mb-4 text-left'>
                                <label className="stride-form-label">{content.UPDATE_USER_MODAL_CONTENT.instruction_text.organization_role.title}</label>
                                <p className='text-xs text-stride-muted mb-2'>{content.UPDATE_USER_MODAL_CONTENT.instruction_text.organization_role.description}</p>
                                <OrganizationRole organizationRole={orgRole} roles={roles} callback={(orgRole) => {
                                    setOrgRole(orgRole);
                                }} />
                            </div>
                            <div className='flex justify-end items-center'>
                                {checkPermission(permission.MANAGE_USERS_OP_EDIT_ROLE) && <button 
                                    type="button" 
                                    className={`text-white bg-primary hover:bg-primary focus:ring-4 focus:outline-none focus:ring-primary-2 font-medium rounded-lg text-sm px-5 py-2.5 text-center ${!userValid && "disabled:border disabled:border-gray-2 disabled:bg-gray-3 disabled:text-black"}`}
                                    disabled={!userValid}
                                    onClick={handleSaveChanges}
                                >
                                    {content.UPDATE_USER_MODAL_CONTENT.save_btn}
                                </button>}
                            </div>
                        </div>
                        <div className='mb-4 text-left'>
                            <label className="stride-form-label">{content.UPDATE_USER_MODAL_CONTENT.instruction_text.update_password.title}</label>
                            <p className='text-xs text-stride-muted mb-2'>{content.UPDATE_USER_MODAL_CONTENT.instruction_text.update_password.description}</p>
                            <div className='flex justify-start space-x-4'>
                                <button className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-stride-body bg-white border border-gray-300 rounded-lg hover:bg-surface focus:outline-none focus:ring-2 focus:ring-primary/20" type="button" onClick={() => { setShowUpdatePassword(true) }}>{content.UPDATE_USER_MODAL_CONTENT.instruction_text.update_password.cta_text}</button>
                            </div>
                        </div>
                        {selectedUser.verification == 'No' && <div className='mb-4 text-left'>
                            <label className="stride-form-label">{content.UPDATE_USER_MODAL_CONTENT.instruction_text.send_verification_link.title}</label>
                            <p className='text-xs text-stride-muted mb-2'>{content.UPDATE_USER_MODAL_CONTENT.instruction_text.send_verification_link.description}</p>
                            <div className='flex justify-start space-x-4'>
                                <button className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-stride-body bg-white border border-gray-300 rounded-lg hover:bg-surface focus:outline-none focus:ring-2 focus:ring-primary/20" type="button" onClick={() => {
                                    startCountdown();
                                }}>{content.UPDATE_USER_MODAL_CONTENT.instruction_text.send_verification_link.cta_text}</button>
                            </div>
                        </div>}
                        { checkPermission(permission.MANAGE_USERS_OP_DEACTIVATE_ACCOUNT) &&
                        selectedUser.organization_role != 'Administrator' && 
                        <div className='relative'>
                            <h2 className="text-xl font-bold leading-tight tracking-tight text-black text-left mb-2">{ !isUserBlocked ? content.UPDATE_USER_MODAL_CONTENT.instruction_text.deactivate_account.title: content.UPDATE_USER_MODAL_CONTENT.instruction_text.activate_account.title}</h2>
                            <p className='text-base leading-tight tracking-tight text-black mb-4'>{ !isUserBlocked ?  content.UPDATE_USER_MODAL_CONTENT.instruction_text.deactivate_account.description: ""}</p>
                            <button className="text-danger bg-white focus:outline-none rounded-lg border border-danger text-sm font-medium px-5 py-2.5" type="button" onClick={()=>{setOpenConfirmDeactivate(true)} }>{!isUserBlocked ?  content.UPDATE_USER_MODAL_CONTENT.instruction_text.deactivate_account.cta_text: content.UPDATE_USER_MODAL_CONTENT.instruction_text.activate_account.cta_text}</button>
                        </div> }
                        <div className='flex justify-end'>
                            <SecondaryButton handleClick={() => {
                                setUpdateUser(false);
                            }}>{ content.UPDATE_USER_MODAL_CONTENT.cancel_cta_text }</SecondaryButton>
                        </div>
                    </div>
                </> }
            </PrimaryModal> }
        </>
    )
}

export default UpdateUserModal;